<template>
  <div class="activity-detail-page" :class = "{'clear-header':isWechatBrowser}">
    <my-header v-if="!isWechatBrowser" class="top-title" :title= "activityTitle" :showBack="true"></my-header>
    <div class="activity-detail-part">
      <img class="activity-banner" :src="activityDetail.banner">
      <div class="activity-info-title-text activity-info-word">活动信息</div>
     <div class="activity-box general-box-shadow">
        <div class="activity-info-row">
        <div class="title">活动标题：</div><div class="content">{{activityDetail.title}}</div>
      </div>
      <div v-if="activityDetail.address" class="activity-info-row">
        <div class="title">活动地址：</div><div class="content">{{activityDetail.address}}</div>
      </div>
      <div class="activity-info-row">
        <div class="title" style="margin-top: -0.05rem">活动时间：</div><div class="content">{{activityDetail.activityDay}}</div>
      </div>
      <div class="activity-info-row">
        <div class="title">活动内容：</div><div class="content" style="display:inline;">{{activityDetail.content}}</div>
      </div>
      <div class="activity-info-row">
        <div class="title">活动状态：</div><div class="content">{{isPreStart ? '活动未开始': isEnd ? '活动已结束':'活动已开始'}}</div>
      </div>
      <div v-if="activityDetail.type == '3'" class="activity-info-row">
        <div class="title">报名人数：</div><div class="content">{{enrollNumContent}}</div>
      </div>
      <div v-if="isPreStart || isUnderway" class="activity-info-row">
        <div class="title">{{isPreStart ? '距离开始' : '距离结束'}}：</div><div class="to-start-time">{{remainTimeStr}}</div>
      </div>
     </div>
    </div>
    <div class="activity-info general-box-shadow">
      <div @click="checkAttention" class="activity-info-title">
        <div class="activity-info-title-text">
          <span>注意事项</span>
          <img v-if="showAttention"  src="../../assets/icon/icon-pull-up.png">
          <img v-if="!showAttention"  src="../../assets/icon/icon-pull-down.png">
        </div>
      </div>
      <div v-if="showAttention" class="activity-info-content" v-html="activityDetail.details"></div>
    </div>
    <div class="activity-info general-box-shadow">
      <div @click="checkActivityPlans" class="activity-info-title">
        <div class="activity-info-title-text">
          <span>活动流程</span>
          <img v-if="showPlan"  src="../../assets/icon/icon-pull-up.png">
          <img v-if="!showPlan"  src="../../assets/icon/icon-pull-down.png">
        </div>
      </div>
      <div v-if="showPlan" class="activity-info-content">
        <div class="activity-table">
          <div v-for="plan in activityPlans" class="activity-flow-item">
            <div class="flow-time">{{plan.time}}</div>
            <div>{{plan.content}}</div>
          </div>
        </div>
      </div>
    </div>
    <mt-loadmore v-if="activityDetail.type == '1'" style="font-size:0.24rem;color: #aaaaaa;position: relative" :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" :auto-fill ='autoFill' bottomLoadingText = '加载更多' ref="loadmore">
    <div class="product-category-list" @scroll.prevent='handleScroll()'>
      <div v-if="categorySelected != 'all'" @click = "selectCategory('all')" class="product-category-item">全部</div>
      <div v-if="categorySelected == 'all'" class="product-category-item category-selected">全部</div>
        <div v-for="(category,index) in productCategoryList" @click = "selectCategory(index,category.id)" class="product-category-item" :class="{'category-selected': categorySelected == index}">{{category.name}}</div>
    </div>

    <div class="activity-shop-list">
      <div v-for="shop in activityShopList" class="shop-item" @click="toActivityShop(shop.id)">
        <div class="shop-info general-box-shadow">
          <img :src="shop.logo">
          <div class="shop-info-row">{{shop.name}}</div>
          <div class="shop-info-row shop-promotion-product-num">
            <span style="color: #7f7d7c">
              特惠商品数:&nbsp;
            </span>
            <span>{{shop.productNumber}} </span></div>
        </div>
      </div>
    </div>
    </mt-loadmore>
    <div v-if="!isEnroll && !isFullAmount && isPreStart" class="bottom-btn" @click="goActivityEnroll">
      去报名
    </div>
    <div v-if="isEnroll" class="bottom-btn">
      已报名
    </div>
    <div v-if="activityType == '3' && isFullAmount && !isEnroll" class="bottom-btn">
      已满额
    </div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import activityService from '../../service/activity/ActivityService'
  import {imgUrl,shareIcon} from "../../config";
  import appTools from '../../utils/Tools'
  import shareService from '../../service/share/ShareService'
  import ProductService from '../../service/product/ProductService'
  import session from '../../utils/Session'

  export default {
    name: 'ActivityDetail',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        activityTitle:'',
        activityContent:'',
        imgUrl: imgUrl,
        shareIcon:shareIcon,
        activityId:'',
        activityDetail:{},
        showAttention:false,
        showPlan:false,
        activityPlans:[],
        activityShopList:[],
        isPreStart: false,
        isEnd: false,
        isUnderway: false,
        remainTime:'',
        remainTimeStr:'',
        isWechatBrowser:this.$verfyBrowserType(),
        allLoaded: false,
        pageNo:1,
        autoFill:false,
        activityType:'1',
        enrollNumContent:'',
        isEnroll:false,
        isFullAmount:false,
        enrollBtnContent:'去报名',
        productCategoryList:[],
        categorySelected:'all',
      }
    },
    created(){
      this.activityId = this.$route.query.activityId;
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      if(this.global.enrollActivityId){
        this.activityId = this.global.enrollActivityId
        this.global.enrollActivityId = '';
      }
      this.loadProductCategoryList();
      session.isLogin().then(flag => {
        if(flag){
          this.loadActivityDetail();
        }else{
          Toast('对不起您还未登录，请登录后再来报名该活动!');
          let backUrl = window.location.href.split('#')[1];
          this.$router.push("/login?backUrl="+backUrl);
        }
      });
    },
    methods: {
      async loadActivityDetail(){
        let {code,msg,data} = await activityService.detail(this.activityId);
        if(code == '0'){
          this.activityDetail = data;
          this.activityType = this.activityDetail.type || '1';
          this.activityTitle = this.activityDetail.title || '活动详情';
          this.activityContent = this.activityDetail.content || '';
          if(this.activityDetail.type == '1'){
            this.loadActivityShopList();
          }
          this.activityEnrollCreate();
          this.activityPlans = JSON.parse(this.activityDetail.plan);
          if(this.activityDetail.status != '4'){
            this.setRemainTime(this.activityDetail.type);
          }else {
            this.isEnd = true;
          }

          if(this.activityDetail.type == '3'){
            let enrollTotal = this.activityDetail.enrollTotal || 0;
            let enrollLimit = this.activityDetail.enrollLimit;
            this.enrollNumContent = '已报名'+enrollTotal+'人/限制人数'+enrollLimit +'人'
            if(enrollTotal >= enrollLimit){
              this.isFullAmount = true;
              this.enrollBtnContent = '已满额';
            }
            this.showAttention = true;
            this.showPlan = true;
          }
          this.initWechatShare();
        }else {
          Toast(msg);
        }
      },
      selectCategory(index,categoryId){
        this.categorySelected = index;
        this.categoryId = categoryId;
        this.pageNo = 1;
        // this.loadActivityShopList();
      },
      async loadProductCategoryList(){
        let {code,msg,data} = await ProductService.categoryList();
        if(code == '0'){
          this.productCategoryList = data.categories;
        }else {
          Toast(msg);
        }
      },
      async activityEnrollCreate(){
        let {code,msg,data} = await activityService.enrollCreate(this.activityId);
        if(code == '0'){
          if(data.count>0){
            this.isEnroll = true;
            this.enrollBtnContent = '已报名'
          }
        }else {
          Toast(msg);
        }
      },
      loadBottom(){
        this.pageNo++;
        this.loadActivityShopList()(()=>{
          this.$refs.loadmore.onBottomLoaded();
        });
      },
      //设置活动剩余时间
      setRemainTime (type) {
        let startTime = appTools.parseDate(this.activityDetail.startTime);
        let endTime = appTools.parseDate(this.activityDetail.endTime);
        let now = new Date();
        if (now.getTime() < startTime.getTime()) {
          //活动未开始
          let remainTime = (startTime.getTime() - now.getTime());
          this.isPreStart = true;
          this.isEnd = false;
          this.isUnderway = false;
          this.remainTime = remainTime;
          this.remainTimeStr = appTools.parseMilliscondToStr(remainTime);
          setTimeout(function () {
            this.countdown();
          }.bind(this), 1000);
        } else if (startTime.getTime() <= now.getTime() && now.getTime() < endTime.getTime()) {
          //活动进行中
          let remainTime = (endTime.getTime() - now.getTime());
          this.isPreStart = false;
          this.isEnd = false;
          this.isUnderway = true;
          this.remainTime = remainTime;
          this.remainTimeStr = appTools.parseMilliscondToStr(remainTime);
          setTimeout(function () {
            this.countdown();
          }.bind(this), 1000);
          if(type == '1'){
            Toast('活动已开始，请选择心仪店铺进行下单吧!')
          }
          this.enrollBtnContent = '活动已开始'
        } else {
          this.isPreStart = false;
          this.isEnd = true;
          this.isUnderway = false;
          this.enrollBtnContent = '活动已结束'
        }
      },
      //倒计时
      countdown(){
        let remainTime = this.remainTime;
        remainTime = remainTime - 1000;
        if (remainTime < 1000) {
          this.setRemainTime();
        } else {
          this.remainTime = remainTime;
          this.remainTimeStr = appTools.parseMilliscondToStr(remainTime);
          setTimeout(function () {
            this.countdown();
          }.bind(this), 1000);
        }
      },
      async loadActivityShopList(onCancel = function(){}){
        if(this.pageNo == 1){
          this.activityShopList = [];
        }
        let {code,msg,data} = await activityService.shopList(this.activityId,this.pageNo);
        if(code == '0'){
          this.activityShopList = [...this.activityShopList , ...data];
          for(let item of this.activityShopList){
            if(item.name.length>'8'){
              item.name = item.name.substring(0,8)+'...';
            }
          }
          this.allLoaded = data ? false:true;
          onCancel();
        }else {
          Toast(msg);
        }
      },
      //查看注意事项
      checkAttention(){
        this.showAttention = ! this.showAttention;
      },
      //查看活动流程
      checkActivityPlans(){
        this.showPlan = ! this.showPlan;
      },
      //去报名参加团购活动
      goActivityEnroll(){
        this.global.enrollActivityId =this.activityId;
        this.$router.push({name: 'ActivityEnroll', query: {activityId:this.activityId}})
      },
      toActivityShop(shopId){
        this.global.enrollActivityId =this.activityId;
        this.$router.push({name: 'ActivityShop', query: {activityId:this.activityId,shopId:shopId}})
      },
      async initWechatShare(){
        let title = this.activityTitle;// 分享标题
        let desc = this.activityContent; // 分享描述
        let link = window.location.href; // 分享链接
        link = link.replace(/#/, '?#')
        await shareService.wechatShare(title,desc,link,this.shareIcon);
      },
    }
  }
</script>
<style lang="scss">
  @import '../../assets/style/common.scss';
  .activity-detail-page {
    padding-bottom: 1.2rem;
    background-color: white;
    font-size: 0.28rem;
    color: #7f7d7c;
    .activity-detail-part{
      .activity-banner{
        height: 3.2rem;
        width: 100%;
      }
      .activity-info-row{
        display:flex;
        padding:0.6em 0.2rem;
        font-size: 0.32rem;
        .content{
          width: 4.8rem;
          color: #191818;
        }
        .to-start-time{
          color: #feac00;
        }
      }
    }
    .activity-box{
      width: 6.9rem;
      height: auto;
      margin-left: 0.3rem;
    }
    .activity-info-title-text{
       padding:0px 0.1rem 0px 0.2rem;
       position:relative;
       display: flex;
       font-size: 0.36rem;
       color: #191818;
       line-height: 1rem;
       font-weight: bold;
    }
    .activity-info-title-text img{
      width: 0.34rem;
      height: 0.2rem;
      position: relative;
      left: 4.6rem;
      top: 0.4rem;
    }
    .activity-info{
      width: 6.9rem;
      font-size:0.28rem;
      margin-top:0.2rem;
      margin-left: 0.3rem;
      .activity-info-title{
        width: 6.9rem;
        margin-top: 0.3rem;
        display:flex;
        flex-flow:row nowrap;
        justify-content:space-between;
      }
      .activity-info-content{
        padding: 0rem 0.2rem 0.5rem;
        font-size: 0.32rem;
        color: #222633;
        img{
          width: 100%;
        }
      }
    }
    .activity-flow-item{
      position: relative;
      margin-left: .47rem;
      padding-left: .83rem;
      padding-bottom: .3rem;
      line-height: .45rem;
      border-left: 2px solid #feac00;
    }
     .activity-flow-item:last-child{
       padding-bottom: 0;
       line-height: .4rem;
       border-left: none;
     }
     .flow-time{
       position: absolute;
       left: -.48rem;
       width: .96rem;
       height: .4rem;
       color: #fff;
       text-align: center;
       line-height: .4rem;
       background-color: #feac00;
       border-radius: .2rem;
     }
    .activity-table-border{
      border-top:1px solid #eaebeb;
      border-left:1px solid #eaebeb;
    }
    .product-category-list{
      display: flex;
      flex-wrap: nowrap;
      height: 0.84rem;
      line-height: 0.88rem;
      margin-left: 0.3rem;
      overflow-x: scroll;
      color: #939599;
      .product-category-item{
        flex-shrink: 0;
        margin-right: 0.3rem;
        font-size: 0.32rem;
        color: #7f7d7c;
      }
      .category-selected{
        font-size: 0.36rem;
        color: #191818;
        font-weight: bold;
      }
    }
    .activity-shop-list{
      display:flex;
      width: 6.9rem;
      margin: 0.1rem 0.3rem 0.47rem;
      .shop-item{
        width:3.3rem;
        height: 4.5rem;
        margin: 0 0.3rem 0.2rem 0;
        box-sizing:border-box;
        .shop-info{
          img{
            width: 3.3rem;
          }
          .shop-promotion-product-num{
            padding-bottom: 0.4em;
          }
          .shop-info-row{
            font-size: 0.32rem;
            color: #191818;
            padding: 0.2em 0.15rem;
            min-height: 1.4em;
          }
        }
      }
    }
   .bottom-btn{
     width: 2.80rem;
     border-radius: 40px;
     font-size: 0.36rem;
     bottom:0px;
     margin: 0.3rem auto 0;
     flex-flow:row wrap;
     z-index:10000;
     text-align:center;
     line-height:0.8rem;
     color:#ffffff;
     letter-spacing: 0.05rem;
     background-color: #feac00;
   }
  }
</style>
